import DarkFrameworkImages from '@vfgroup-oneplatform/framework/Themes/Modes/Dark/Images'

import images from '../../Images'

const Images = {
  ...DarkFrameworkImages,
  smsText: images.smsText_white,
  emptyList: images.sms_light,
}

export default Images
